import { motion } from "framer-motion";
import styled from "styled-components";
import { InitialIcon } from "../../assets/Icons/InitialIcon";
import { T } from "../../styles/Theme";
import { useEffect, useState } from "react";
import { POSITION_RIGHT_VALID_URLS } from "../../env";

interface StartButtonProps {
  modalOpen: boolean;
  close: () => void;
  open: () => void;
}

const StartButton = ({ modalOpen, close, open }: StartButtonProps) => {

  const [position, setPosition] = useState<string>("right");

  useEffect(() => {
    const url = window.location.search.split("?")[1];
    if (POSITION_RIGHT_VALID_URLS.has(url)) {
      setPosition("right");
    } else {
      setPosition("left");
    }
  }, [])
  
  const handleOnClick = () => {
    const url = window.location.search.split("?")[1];
    if (modalOpen) {
      window.parent.postMessage("collapse", url);
    } else {
      window.parent.postMessage("expand", url);
    }
    modalOpen ? close() : open();
  };

  return (
    <>
      {(position === "right") && (
        <StartButtonStyledRight
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="buttonTrigger"
          onClick={handleOnClick}
        >
          <InitialIcon /><span>Recomendador</span>
        </StartButtonStyledRight>
      )}
      {(position === "left") && (
        <StartButtonStyledLeft
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="buttonTrigger"
          onClick={handleOnClick}
        >
          <span>Recomendador</span><InitialIcon />
        </StartButtonStyledLeft>
      )}
    </>
  );
};

const StartButtonStyledRight = styled(motion.div)`
  box-shadow: 0px 0px 1px 1px #0000001a;
  animation: pulse-animation 2s infinite;

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
    }
    100% {
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }
  }

  & > span {
    font-size: 18px;
    font-weight: ${T.fontWeights.bold};
    text-align: center;
    color: #000000;
    padding: 5px;
  }
  & > svg {
    transform: scale(0.8);
  }

  position: fixed;
  bottom: 15px;
  right: 0;
  cursor: pointer;
  display: flex;
  padding-left: 15px; 
  align-items: center;
  width: 200px;
  height: 60px;
  border-radius: 30px 0 0 30px;
  background-color: ${T.secondary};
`;

const StartButtonStyledLeft = styled(motion.div)`
  box-shadow: 0px 0px 1px 1px #0000001a;
  animation: pulse-animation 2s infinite;

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
    }
    100% {
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }
  }

  & > span {
    font-size: 18px;
    font-weight: ${T.fontWeights.bold};
    text-align: center;
    color: #000000;
    padding: 5px;
  }
  & > svg {
    transform: scale(0.8);
  }

  position: fixed;
  bottom: 15px;
  left: 0;
  cursor: pointer;
  display: flex;
  padding-left: 15px; 
  align-items: center;
  width: 200px;
  height: 60px;
  border-radius: 0 30px 30px 0;
  background-color: ${T.secondary};
`;

export default StartButton;
